class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-drawer");
    this.header = document.querySelector("sticky-header");
    this.closebutton = document.querySelector(".cart__close");
    this.closebutton.addEventListener("click", (e) => {
      this.close();
    });
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.cartIcon = document.querySelector(".header_icon-cart");
    this.cartIcon?.addEventListener("click", (e) => {
      e.preventDefault();
      this.notification.classList.contains("active") ? this.close() : this.open();
    });
    this.announcementBar = document.querySelector("announcement-rotator");
    this.headerTop = document.querySelector(".header-top");

    // Send out event when cart changes
    document.addEventListener("rebuy:cart.change", (event) => {
      const cartHasSubGift = event.detail.cart.cart.items.some((item) => item.properties._isFreeSubGift);
      if (cartHasSubGift) {
        document.body.classList.add("subgift-in-cart");
      } else {
        document.body.classList.remove("subgift-in-cart");
      }
    });
  }

  open() {
    const announcementHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
    const headerTopHeight = this.headerTop ? this.headerTop.offsetHeight : 0;
    const headerOffset = document
      .getElementById("shopify-section-header")
      .classList.contains("shopify-section-header-sticky")
      ? this.header.offsetHeight
      : this.header.offsetHeight + announcementHeight + headerTopHeight;
    this.notification.classList.add("animate", "active");
    document.body.classList.add("is-cart-drawer-active");
    document.documentElement.style.setProperty("--header-offset", `${headerOffset + 36}px`);

    setTimeout(() => {
      document.body.addEventListener("click", this.onBodyClick);
    }, 100);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.classList.remove("is-cart-drawer-active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });

    // if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
      },
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: ".js-contents",
      },
      {
        id: "main-cart-footer",
        section: "main-cart-footer",
        selector: "#main-cart-footer",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  handleBodyClick(e) {
    if (!this.notification.contains(e.target)) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);
